import { useContext } from "react";
import useCreditWallet from "./useCreditWallet";
import { AuthContext } from "../context/AuthContextProvider";

/**
 * useSendForInterpretation
 * Shared credit-exhaustion logic for the "Send for Interpretation" dialogs.
 * Only the actual b2b business owner can pay-and-send in one action when
 * credits are exhausted - other center roles (b2b-admin/b2b-member/b2b-doctor)
 * see a blocked "ask your account owner" message instead, since the top-up
 * routes themselves are 'b2b'-only.
 */
const useSendForInterpretation = () => {
  const { user } = useContext(AuthContext);
  const wallet = useCreditWallet();
  const { credits, isUnlimitedCredits, canTopUp } = wallet;

  const outOfCredits = !isUnlimitedCredits && Number(credits) <= 0;
  const isBusinessOwner = user?.userType === "b2b";
  const canPayAndSend = outOfCredits && isBusinessOwner && canTopUp;

  return {
    ...wallet,
    outOfCredits,
    isBusinessOwner,
    canPayAndSend,
  };
};

export default useSendForInterpretation;
